import React from "react";
import { ManageCompanyLayout, AccountBalanceComponent } from "../../components";

const buttons = [];

function CompanyAccountBalanceContainer(props) {
  return (
    <>
      <ManageCompanyLayout buttons={buttons}>
        <div className="w-100">
          <AccountBalanceComponent />
        </div>
      </ManageCompanyLayout>
    </>
  );
}

export default CompanyAccountBalanceContainer;
